import { Dispatch } from "redux";
import { ApiConfig } from '../../../../config';
import { Task } from "../../../../models";
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes";
import { createRequestThunk, RequestThunkParameters } from "../../../../utils/request-actions-helpers/createRequestThunk";
import { AppStateWithData } from "../../../AppStateWithData";
import { processSingleTaskResponse, TaskResponse } from "./processTasksResponse";

export const createTaskActionTypes = createRequestActionTypes('CREATE_TASK')

export interface CreateTaskAdditionalData {
    checklistUid: string
}

export const createTaskApiCall = (config: ApiConfig) => (docId: string, checklistUid: string, text: string) =>
    async (dispatch: Dispatch, getState: () => AppStateWithData) => {
        const thunkParams: RequestThunkParameters<Task[], never, CreateTaskAdditionalData> = {
            method: 'POST',
            requestActionTypes: createTaskActionTypes,
            url: `${config.API_URL}/tasks?docId=${encodeURIComponent(docId)}&checklistUid=${encodeURIComponent(checklistUid)}&text=${encodeURIComponent(text)}`,
            processResultBeforeDispatch: (task: TaskResponse) => {

                if (config.updateItem) {
                    config.updateItem(docId)
                }

                return [processSingleTaskResponse(task)]
            },
            actionAdditionalData: {
                checklistUid
            }
        }

        dispatch<any>(createRequestThunk(thunkParams))
    }